<template>
    <div class="btn-group">
        <template v-for="tab in tabs">
            <router-link class="btn btn-default" tag="button" :to="tab.target" :class="{ active: tab.active }" @click.native="getSoundClick" v-if="tab.visible">{{ $t(tab.label) }}</router-link>
        </template>
    </div>
</template>

<script>
import { soundClick } from '../../utils/utils';

export default {
    name: 'UpgradeNavTabs',
    computed: {
        user_info() {
            return this.$store.state.user_info;
        },
        tabs() {
            const current = this.$route.name
            return [
                { label: 'upgrade_account', target: { name: 'upgrade_account' }, active: current === 'upgrade_account', visible: true },
                { label: 'upgrade_feature', target: { name: 'upgrade_feature' }, active: current === 'upgrade_feature', visible: true },
            ]
        }
    },

    methods: {
        getSoundClick() {
            soundClick();
        },
    }
}
</script>

<style scoped>
.btn-group {
    border-radius: 8px;
    background: #3263C0;
    box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.15);
}

.btn-group button {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: #FFFFFF;
    padding: 9px 24px;
}

.btn-group button.active {
    background: #5AC9F7;
    border-radius: 8px !important;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: #FFFFFF;
    box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.15);
}
</style>